"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fmoney = fmoney;
const lang_1 = require("./lang");
const mround_1 = require("./mround");
const precisionsz = ['', '.0', '.00', '.000', '.0000', '.00000', '.000000', '.0000000', '.00000000'];
/**
 * formatuje liczbę zmiennoprzecinkową do polskiego formatu
 * @param value liczba
 * @param forcezeros czy zachować zera ,00
 * @param precision do ilu miejsc po przecinku zaokrąglić, domyślnie 2
 */
function fmoney(value, forcezeros, precision = 2, lang) {
    var _a;
    if (value === null) {
        return '';
    }
    const sep = ((_a = lang !== null && lang !== void 0 ? lang : this === null || this === void 0 ? void 0 : this.lang) !== null && _a !== void 0 ? _a : lang_1.defaultLang.current).decimalSeparator;
    if (value % 1 === 0) {
        if (forcezeros) {
            return value.toFixed(0) + (sep == '.' ? precisionsz[precision] : precisionsz[precision].replace('.', sep));
        }
        else {
            return value.toFixed(0);
        }
    }
    let s = (0, mround_1.mround)(value, precision).toFixed(precision);
    if (!forcezeros)
        s = s.replace(precisionsz[precision], '');
    if (sep != '.')
        return s.replace('.', sep);
    return s;
}
//# sourceMappingURL=fmoney.js.map